module.exports = __webpack_public_path__ + "static/ability-desktopimg-18c196c28678c2bd3495a79e78933d67.png";